export const SUMMARY_FILTER_QUERY_KEY = "summary_filter";

export const PRESET_ONGOING = "ongoing";

export const PRESET_ACTIVE_PICKUP = "active_pickup";

export const ACTIVE_PICKUP_STATUSES = ["CRRNFD", "CRROTW"];

export function parseSummaryFilterQuery(query: any) {
  return query?.[SUMMARY_FILTER_QUERY_KEY] ?? null;
}

export function buildSummaryFilterQuery(filterState: any) {
  if (filterState.isOngoing) {
    return {
      [SUMMARY_FILTER_QUERY_KEY]: PRESET_ONGOING
    };
  }

  if (filterState.isActivePickup) {
    return {
      [SUMMARY_FILTER_QUERY_KEY]: PRESET_ACTIVE_PICKUP
    };
  }

  return {};
}

export function applyOngoingFilterToAdvanceFilterData(
  current: any,
  nestedStatusOptions: any[]
) {
  const ongoing =
    nestedStatusOptions?.[0]?.children?.map((item: any) => item.value) ?? [];

  return {
    ...current,
    nestedStatus: ongoing
  };
}

export function applyActivePickupFilterToListPickupFilter(current: any) {
  return {
    ...current,
    lsLastStatus: ACTIVE_PICKUP_STATUSES
  };
}
